module.exports = __webpack_public_path__ + "img/perforadat.91d268b6.png";